import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import { useJourneyStatus } from "../app/hooks/useJourneyStatus";
import { getJourneyTypeForPath } from "../../routes/admin/utils";
import {
  TutorialJourneyStatus,
  TutorialJourneyType,
} from "@growth-machine-llc/stridist-api-client";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { JourneyAvailabilityContext } from "../../contexts/JourneyAvailabilityContext";
import { JourneyRunContext } from "../../contexts/JourneyRunContext";
import { useMediaMobile } from "../../hooks/useMediaMobile";

interface JourneyButtonProps {
  className?: string;
  onStart?: () => void;
  size?: "small" | "medium" | "large";
}

export const JourneyButton: React.FC<JourneyButtonProps> = ({
  className,
  onStart,
  size = "medium",
}) => {
  const { enabled, disabledReason } = useContext(JourneyAvailabilityContext);

  const { pathname, search } = useLocation();
  const user = useCurrentUser();
  const isMobile = useMediaMobile("md", false);

  const journeyType = useMemo(
    () => getJourneyTypeForPath(pathname, search),
    [pathname, search],
  );
  const journeyStatus = useJourneyStatus(journeyType!);

  const isAvailable = !!journeyType && journeyStatus !== undefined;
  const hideButton =
    journeyStatus === TutorialJourneyStatus.DRAFT && !user?.admin;

  if (!isAvailable || hideButton) return null;
  if (isMobile) return null;

  return (
    <Tooltip
      title={!enabled && disabledReason ? disabledReason : "Tips & Tricks"}
      placement="top"
    >
      <span>
        <IconButton
          className={className}
          size={size}
          onClick={onStart}
          disabled={!enabled}
        >
          <LightbulbOutlinedIcon fontSize={size} />
        </IconButton>
      </span>
    </Tooltip>
  );
};
